var DecoratedAvatarData = /** @class */ (function () {
    function DecoratedAvatarData() {
        this.avatarSize = 32;
        this.badgeStatusSize = 2;
        this.badgeTypeSize = 10;
        this.isRequester = false;
        this.haveDropdown = false;
        this.hideStatus = false;
        this.hideType = false;
        this.disabled = false;
        this.hideName = true;
    }
    return DecoratedAvatarData;
}());
export { DecoratedAvatarData };
//# sourceMappingURL=decorated-avatar-data.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-dto/avatar/decorated-avatar-data.js
// module id = 984
// module chunks = 14